import React from 'react'

const AdminMerchantList = () => {
  return (
    <div>AdminMerchantList</div>
  )
}

export default AdminMerchantList